var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailedPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4631 3.40114C15.1539 3.09198 14.6527 3.09198 14.3435 3.40115L13.3904 4.35421L14.51 5.4738L15.4631 4.52073C15.7722 4.21156 15.7722 3.71031 15.4631 3.40114ZM16.5827 5.64032C17.5102 4.71282 17.5102 3.20905 16.5827 2.28156C15.6552 1.35406 14.1514 1.35407 13.2239 2.28156L11.7112 3.79424L4.00257 11.5029C3.98306 11.5224 3.96377 11.5417 3.94471 11.5607C3.33515 12.1702 2.95189 12.5533 2.65183 12.9992C2.386 13.3942 2.17218 13.8219 2.01567 14.2715C1.839 14.7791 1.76242 15.3156 1.64062 16.1689C1.63681 16.1956 1.63295 16.2226 1.62905 16.2499L1.59148 16.5129C1.55512 16.7675 1.64467 17.0239 1.83164 17.2004C2.01861 17.377 2.27969 17.4517 2.53177 17.4009L2.99056 17.3083C3.75736 17.1537 4.23955 17.0564 4.69497 16.8772C5.09854 16.7183 5.48207 16.5127 5.83768 16.2644C6.23896 15.9842 6.58673 15.6364 7.13978 15.0832C7.15702 15.066 7.17447 15.0485 7.19213 15.0308L16.5827 5.64032ZM13.3904 6.59338L12.2708 5.4738L5.12216 12.6225C4.43624 13.3084 4.16952 13.5799 3.96541 13.8832C3.77553 14.1654 3.62281 14.4708 3.51101 14.792C3.43509 15.0101 3.38431 15.2406 3.32262 15.623C3.69404 15.5426 3.91065 15.4843 4.11505 15.4039C4.40332 15.2904 4.67727 15.1435 4.93128 14.9662C5.20429 14.7755 5.45036 14.5334 6.07254 13.9113L13.3904 6.59338Z",
    fill: "#CB0202"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedPencil);
export default __webpack_public_path__ + "static/media/failed-pencil.eacb9348cbf9b984ad9323e6bf30d2be.svg";
export { ForwardRef as ReactComponent };